
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import { useQueryClient, useMutation } from '@tanstack/react-query';

import { Radio } from "@mui/material";
import { RadioGroup } from "@mui/material";
import { FormControlLabel } from "@mui/material";
import NumberFormat from "react-number-format";
import { TextField } from "@mui/material";

import { Button } from "antd";

import authAxios from "../../components/authAxios";

import UserAlerts from "../../components/UserAlerts";
import DashboardHeader from "../../components/DashboardHeader";


function SupplierNew() {
    const errorRef = useRef(null);
    const [error, setError] = useState('');
    const queryClient = useQueryClient();

    const navigate = useNavigate();

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [mobile, setMobile] = useState('');
    const [address, setAddress] = useState('');
    const [city, setCity] = useState('');
    const [website, setWebsite] = useState('');
    const [type, setType] = useState('10');
    const user = localStorage.getItem('userID');
    const client = localStorage.getItem('clientID');
    const [tag, setTag] = useState('SUPPLIER');
    const [isPerson, setIsPerson] = useState(false);

    const handleCustomerType = (e) => {
        setType(e.target.value)
        if (e.target.value==="10"){
            setIsPerson(true)
        }
        else {
            setIsPerson(false)
        }
    }


    const mutation = useMutation({
        mutationFn: (supplier) => {
            return authAxios.post('/contacts/', supplier, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
            });
        },
        onError: (error, variables, context) => {
            console.log("ERROR",error)

            if (error.response.data.error){
                // If it's an array, display each error message
                if (Array.isArray(error.response.data.error)) {
                    error.response.data.error.map((errorMessage) => (
                        setError(errorMessage)
                    ));
                } else {
                    // Handle single error message
                    setError(error.response.data.error); 
                }
            } else {
                // Fallback to Standard error message
                setError(error.message); 
            }      
        },
        onSuccess: (result) => {
            queryClient.invalidateQueries(['suppliers']);
            navigate('/dashboard/suppliers/');

        },
      })


    const handleSubmit = (e) => {
        e.preventDefault();


        if (name === '' ) {
            setError("Name is required")
            return
        }

        const telephone = mobile.replace(/[()" "]/g,"")

        const category = tag
        const supplier = { type, client, name, address, city, email, website, telephone, user, tag, category };
        console.log(supplier)
        mutation.mutate(supplier)    
    }

    useEffect(()=>{
        if (error){
            errorRef.current.scrollIntoView();  
        }            
    },[error])

    return(



    <div className="dashboard-main">
        <section className="dashboard-content">

            <section className="dashboard-form">
                <div ref={errorRef}>
                    <UserAlerts error={error}  />
                </div>

                <DashboardHeader dashboardTitle="Add Supplier" dashboardPreTitle="Purchase" />

                <form noValidate autoComplete="off" onSubmit={handleSubmit}>
                    <div className="grouped-fields-light">

                        <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            defaultChecked=""
                            onChange={handleCustomerType}

                            // onChange={(e) => setType(e.target.value)}
                            // className="custom-input"
                        >
                            <FormControlLabel className="custom-radio" value="10" control={<Radio />} label="Individual" />
                            <FormControlLabel className="custom-radio" value="20" control={<Radio />} label="Company" />
                        </RadioGroup>

                        <TextField className="custom-input"
                            onChange={(e) => {
                                // setNameError(false)
                                setName(e.target.value)
                            }}
                            label="Name" 
                            variant="outlined" 
                            fullWidth
                            required
                            // error={nameError}
                        />
                    </div>
                    <div className="grouped-fields-light">
                        <NumberFormat 
                            onChange={(e) => {
                                // setMobileError(false)
                                setMobile(e.target.value)
                            }}
                            className="custom-input"
                            fullWidth
                            label="Telephone" 
                            variant="outlined" 
                            customInput={TextField}
                            format="### (###) ######" mask="_"
                            required
                            // error={mobileError}
                        />


                        <TextField className="custom-input"
                            onChange={(e) => {
                                // setEmailError(false)
                                setEmail(e.target.value)
                            }}
                            label="Email" 
                            variant="outlined" 
                            fullWidth
                            required
                            // error={emailError}
                        />

                        {isPerson === false &&

                        <TextField className="custom-input"
                            onChange={(e) => setWebsite(e.target.value)}
                            label="Website" 
                            variant="outlined" 
                            fullWidth
                            // required
                            // error={mobileError}
                        />  
                        }
                    </div>
                    <div className="grouped-fields-light">

                    <TextField className="custom-input"
                        onChange={(e) => {
                            // setAddressError(false)
                            setAddress(e.target.value)
                        }}
                        label="Physical Address" 
                        variant="outlined" 
                        fullWidth
                        required
                        // error={addressError}
                    />  

                    <TextField className="custom-input"
                        onChange={(e) => {
                            // setCityError(false)
                            setCity(e.target.value)
                        }}
                        label="City/Town" 
                        variant="outlined" 
                        fullWidth
                        required
                        // error={cityError}
                    />  
                    
                </div>

                <div className="button-border-top">
                    <Button 
                        type="primary" 
                        htmlType="submit"
                        loading={mutation.isLoading}
                    >
                        Save
                    </Button>
                </div>


                </form>

            </section>
        </section> 

    </div>

    )

}

export default SupplierNew;
